import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { EvSliderComponent } from '../../../ui-components/ev-slider/ev-slider.component';
import { ModalOptionPanelComponent } from '../../../modals/modal-option-panel/modal-option-panel.component';

export interface SliderProperty {
  id: string;
  label: string;
  displayValue: string;
  min: number;
  max: number;
  digit: number;
  altString: string;
  value: number;
  visible: boolean;
}

@Component({
  standalone: true,
  selector: 'app-vehicle-property',
  templateUrl: './vehicle-property.component.html',
  styleUrls: ['./vehicle-property.component.scss'],
  imports: [EvSliderComponent, ModalOptionPanelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehiclePropertyComponent {
  @Input() label!: string;
  @Input() displayValue!: string;
  @Input() min!: number;
  @Input() max!: number;
  @Input() digit!: number;
  @Input() altString!: string;
  @Input() value!: number;
  @Input() stepButtons: boolean = false;

  @Output() valueDragEvent = new EventEmitter<number>();
  @Output() valueChangeEvent = new EventEmitter<number>();

  // step by the smallest displayed unit (1 for digit 0, 0.1 for digit 1, ...)
  onStep(direction: number): void {
    const increment = Math.pow(10, -this.digit);
    const value = +Math.min(this.max, Math.max(this.min, this.value + direction * increment)).toFixed(this.digit);
    if (value === this.value) {
      return;
    }
    this.value = value;
    this.valueDragEvent.emit(value);
    this.valueChangeEvent.emit(value);
  }

  onValueDrag(value: number): void {
    this.value = value;
    this.valueDragEvent.emit(value);
  }

  onValueChange(): void {
    this.valueChangeEvent.emit(this.value);
  }
}
